var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"FractavaNotes"},[_c('navbar',{style:({height: _vm.navbarHeight+'%'}),attrs:{"navbarHeight":_vm.navbarHeight}}),_c('pageContainer',{style:({height: 100-_vm.navbarHeight+'%'}),nativeOn:{"scroll":function($event){return _vm.scroll.apply(null, arguments)}}},[_c('page')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }